import useMappingProfileDelete from 'api/mappingProfile/useMappingProfileDelete/useMappingProfileDelete';
import useMappingProfileList from 'api/mappingProfile/useMappingProfileList/useMappingProfileList';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import MappingProfileEditModal from 'components/shared/Modals/mappingProfile/MappingProfileEditModal/MappingProfileEditModal';
import MappingProfileInsertModal from 'components/shared/Modals/mappingProfile/MappingProfileInsertModal/MappingProfileInsertModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useMappingProfilTableColumns from 'hooks/mappingProfile/useMappingProfilTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const MappingProfile = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getMappingProfileList, loading, mappingProfileList, pageRef] =
    useMappingProfileList();

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenCode, setEditChosenCode] = useState({});

  const navigate = useNavigate();
  const [deleteRequest] = useMappingProfileDelete();
  const { can } = usePermissions();

  const mappingProfilePermissions =
    permissions.general.categories.globalSettings.coddingSettings.mappingProfile;

  const canCreate = can(mappingProfilePermissions.create);
  const canEdit = can(mappingProfilePermissions.edit);
  const canDelete = can(mappingProfilePermissions.delete);
  const canDetail = can(mappingProfilePermissions.detail);

  const tableRef = useRef(null);

  useEffect(() => {
    getMappingProfileList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getMappingProfileList({ page, count: pageSize });
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/mappingIndex/${row.id}`),
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenCode(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useMappingProfilTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    tableRef,
    {
      canDetail,
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(
      id,
      getMappingProfileList,
      setIsDeleteModalOpen,
      setDeleteLoading,
    );
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getMappingProfileList({
      page: pageNumber,
      count: pageSize,
      term: lastSearch,
    });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getMappingProfileList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(mappingProfileList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={mappingProfileList[page]}
          rows={mappingProfileList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت مپ پروفایل' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canCreate ? (
        <MappingProfileInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getMappingProfileList={getMappingProfileList}
        />
      ) : null}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <MappingProfileEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenBasket={editChosenCode}
          getMappingProfileList={getMappingProfileList}
        />
      ) : null}
    </>
  );
};

export default MappingProfile;
